import { CreativesFilters, CreativeStatus } from 'components/common/types/Creative.types';

export const parseStatusFilter = (statusFilter: string): Pick<CreativesFilters, 'status' | 'automatic'> => {
  const tokens = statusFilter
    ?.split(',')
    .map((token) => token.trim())
    .filter(Boolean);
  const rejectedAutoToken = `${CreativeStatus.REJECTED}:true`;

  const hasRejectedAuto = tokens.includes(rejectedAutoToken);
  const hasRejectedManual = tokens.some(
    (token) => token.split(':')[0] === CreativeStatus.REJECTED && token !== rejectedAutoToken,
  );

  return {
    status: [...new Set(tokens.map((token) => token.split(':')[0]))],
    automatic: hasRejectedAuto !== hasRejectedManual ? String(hasRejectedAuto) : undefined,
  };
};
